import { render, staticRenderFns } from "./PageAbout.vue?vue&type=template&id=3286f30f&scoped=true"
import script from "./PageAbout.vue?vue&type=script&lang=js"
export * from "./PageAbout.vue?vue&type=script&lang=js"
import style0 from "./PageAbout.vue?vue&type=style&index=0&id=3286f30f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3286f30f",
  null
  
)

export default component.exports